export const blockIconsCommonactionsHelpNew = (
	<span className='material-symbols-outlined'>help</span>
);
